import React, { useState, useEffect } from 'react';
import './FloatBar.css';

export default function FloatBar({ onGetSolution }) {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const handler = () => setShowTop(window.scrollY > 300);
    window.addEventListener('scroll', handler, { passive: true });
    return () => window.removeEventListener('scroll', handler);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <div className="float-bar">
      <button className="float-btn" onClick={onGetSolution} title="获取方案">
        <span className="float-icon">📋</span>
        <span className="float-label">获取方案</span>
      </button>
      {showTop && (
        <button className="float-btn float-top" onClick={scrollToTop} title="返回顶部">
          <span className="float-icon">↑</span>
        </button>
      )}
    </div>
  );
}
